require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-andrew-kvalheim-bs-geofire.json") })
        }
      }, "path---package-unpublished-andrew-kvalheim-bs-geofire");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-andrew-kvalheim-bs-geofire!./.cache/json/package-unpublished-andrew-kvalheim-bs-geofire.json
// module id = 930
// module chunks = 231608221292675